import { Popover } from '@extend/antd/popover';
import { PopoverProps } from 'antd/lib/popover';
import React from 'react';

const PopoverWithMasking = (props: PopoverProps) => {
  React.useEffect(() => {
    if (props.visible) {
      const maskDiv = document.createElement('div');
      maskDiv.className = 'custom-popover-modal-mask';
      document.body.appendChild(maskDiv);

      return () => {
        document.body.removeChild(maskDiv);
      };
    }
    return () => {};
  }, [props.visible]);

  return (
    <>
      <Popover
        className={'app-popover-no-arrow'}
        style={{
          background: '#F4F5F6',
        }}
        overlayStyle={{ paddingTop: 20 }}
        {...props}
      >
        {props.children}
      </Popover>
    </>
  );
};

export default PopoverWithMasking;
